import React from 'react';
import SpinLoader from './SpinLoader';
import { useTranslation } from 'react-i18next';
import { CANCEL, SAVE } from '../../../../../i18n/keyConstants';


const ActionButtons = ({ onCancel, onSave, isSaving, buttonText }) => {
    const { t } = useTranslation(['shared']);
    return (
        <div className='crm-action-buttons-container'>
            <button disabled={isSaving} className='btn btn-sm btn-light mr-2' onClick={onCancel}>
                {t(CANCEL)}
            </button>
            <button className='btn btn-sm btn-success save-button' onClick={onSave}>
                <div className={isSaving ? 'invisible' : ''}>{buttonText ? buttonText : t(SAVE)}</div>
                <SpinLoader isLoading={isSaving} />
            </button>
        </div>
    );
};

export default ActionButtons;
